import axios from 'axios'
import { getBpIdParam } from '../../common/helper'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'

const getWhatsNewTour = async () => {
  const bpIdParam = getBpIdParam()
  const { data } = await axios.get(
    `${buildURL('getWhatsNewTour', apiConfig.whatsNewTour)}${bpIdParam}`,
  )
  return data
}

export default getWhatsNewTour
